<template>
  <div :class="`tdesk-${importance}-notice ${type}`">
    <i :class="`fal ${icon}`"></i>
    <p class="tdesk-notice-content">{{ message }}
      <a :href="link.href"
         :target="link.target"
         :data-url="link.href"
         :data-remote="link.remote"
         v-if="link">
        {{ link.text }}
      </a>
      {{suffix}}
    </p>
  </div>
</template>

<script>
  export default {
    name: 'tdesk-notice',
    props: {
      link: {},
      suffix: {
        type: String,
        required: false
      },
      type: String,
      message: String,
      icon: String,
      importance: {
        default: 'primary'
      }
    }
  };
</script>
